
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../services/timesheetreportsService';
import {timesheetuserService} from '../services/timesheetUserservice';
import {timesheetService} from '../services/timesheetService';
import {formatterhelper} from '../helpers/dateformatter';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch, FaTrash,FaPlusSquare } from "react-icons/fa";
import { Paginator } from 'primereact/paginator';
import {loader} from '../compnents/loadermd';
import {dataExporthelper} from '../helpers/exporthelper';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import {Mandate} from '../compnents/formcomp';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
var XLSX = require("xlsx");
const FinalbillDelete = () => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        fromdate: '',
        todate: '',
        employee: 'ALL',
        client: 'ALL',
        subclient: 'ALL',
      });

    const [formData2,setFormData2] = useState({
        // fromdate: '',
        // todate: '',
        // employee: 'ALL',
        values: '',
    });  

    const [formData3, setFormData3] = useState({
        selectmonth: '',
        selectuser:'',
        client: '',
        subclient: '',
        value: '',
      });
    const [adjustmentvalues,setadjustmentvalues] = useState({});
    const [datacomp,setDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [clientscomp,setClientscomp1] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [isdataexported,setDataexport] = useState(true);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [errors, setErrors] = useState({});
    const [adjustdata,setadjdata] = useState([]);
    const [popupvisible,setVisibility] = useState(false);
    const [popupvisible2,setVisibility2] = useState(false);
    const [userscomp,setUserscomp] = useState([]); 
    
     useEffect(()=>{
        _getclientslist();
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
        
        if(name == 'client'){
            _getsubclient({clientid:value}); 
        }
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};

        if (formData.fromdate == '') {
            newErrors.fromdate = 'Field is required';
            valid = false;
          }

          if (formData.todate == '') {
            newErrors.todate = 'Field is required';
            valid = false;
          }  

        if (formData.employee == '') {
          newErrors.employee = 'Field is required';
          valid = false;
        }

        if (formData.client == '') {
            newErrors.client = 'Field is required';
            valid = false;
          }

          if (formData.subclient == '') {
            newErrors.subclient = 'Field is required';
            valid = false;
          }  
       setErrors(newErrors);
       return valid; 
    }  

    const handleSubmit = (e) => {
        e.preventDefault();

        // if(!validateForm()){
        //      return; 
        // }
        let reportobj = {
          'clientid':formData.client,
          'frmdt':formatterhelper.dateformatter({date:formData.fromdate}),
        };
        setfilterobj(reportobj);
        getadjustmentdata(reportobj);    
    };

    function getadjustmentdata(reportobj){
       
        setloading(false);
        timesheetService.getfinaladjustment(reportobj).then((response)=>{        
            console.log("response");
            console.log(response);  
            if(response.status == 200){
                setadjdata(response.data.data);  
                setloading(true);
                setDatastate(true);
            }else{
                setadjdata([]);
                setloading(true);  
            }
        }).catch((error)=>{
            console.log(error);
            setadjdata([]);  
            setloading(true);
        });    
    }

  const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Timesheet', detail: 'Canceled', life: 3000 });
   }


  function deleteitem(deleteitem){
    //    console.log(deleteitem);
    confirmDialog({
        message: 'Are you sure you want to proceed?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        defaultFocus: 'accept',
        accept: () => {
            let data = {'id':deleteitem};
            timesheetService.deletefinaladjustment(data).then((response)=>{
                 if(response.status == 200){
                     toast.current.show({ severity: 'success', summary: 'Adjsutment data', detail: 'Deleted successfully', life: 3000 });       
                     getadjustmentdata(filterobj);
                 }else{
                     toast.current.show({ severity: 'error', summary: 'Adjustment data', detail: 'Not deleted', life: 3000 });     
                 }
            }).catch((error)=>{
                console.log(error);
                toast.current.show({ severity: 'error', summary: 'Adjustment data', detail: 'Error', life: 3000 });     
            }); 
        },
       //  accept,
        reject
    });  

  }


   function editadjustment(values){
       console.log('edit adjustment');    
       console.log(values);
       setadjustmentvalues(values);  
       setVisibility(true);
   }

   function handlechangeddata(e){
        const { name, value } = e.target;
        setadjustmentvalues((prevData) => ({
        ...prevData,
        [name]: value,
        }));
        
        if(name == 'client'){
            _getsubclient({clientid:value}); 
        } 
   }

   function handleSubmitform2(e){
     e.preventDefault();
     updateadjustment(adjustmentvalues);
   }

   function updateadjustment(adjustmentvalues){
     console.log('update adjustment');  
     console.log(adjustmentvalues);
     timesheetService.updatefinaladjustment(adjustmentvalues).then((response)=>{
        if(response.status == 200){
            toast.current.show({severity:'success', summary: "Final bill updation", detail:`Adjustment Updated`, life: 3000});          
            getadjustmentdata(filterobj);
            setVisibility(false);
        }else{
            toast.current.show({severity:'error', summary: "Final bill updation", detail:`Not updated`, life: 3000});          
        }  
     }).catch((error)=>{
        toast.current.show({severity:'error', summary: "Final bill updation", detail:`Error`, life: 3000});          
     });
   }

    function displayadjsdata(){
        let tempdata = [];
        adjustdata.forEach((values,index)=>{
               
            tempdata.push(
                 <tr>
                    <td>{index + 1}</td>
                    <td>{values.from_date}</td>
                    <td>{values.name}</td>
                    <td>{values.client}</td>
                    <td>{values.subclient}</td>
                    <td>{values.value}</td>
                    <td><button className='btn btn-success' onClick={() => editadjustment(values)}><FaEdit/></button>
                        &nbsp;
                        <button className='btn btn-danger' onClick={() => deleteitem(values.id)}><FaTrash/></button>
                    </td>
                 </tr>
            );       
        });
        return tempdata;
    }
    
    function getreports({reportobj,pageno}){
        let emparr = [];
        setloading(false);
        timesheetreportService.showreportgettimesheet({formdataobj:reportobj,pageno:pageno})
        .then((response)=>{
            console.log('get reports');
            console.log(response);

            if(response.status == 200){
                response.data.data.data.forEach((value,index) =>{
                    emparr.push((<tr>
                        <th>{value.ID}</th>
                        <td>{value.Date}</td>
                        <td>{value.User}</td>
                        <td>{value.client}</td>
                        <td>{value.subclient}</td>
                        <td>budget</td>
                        <td>{value.Task}</td>
                        <td>{value.user_role}</td>
                        <td>{value.user_roletype}</td>
                        <td>{value.BilledMinutes}</td>
                        <td>{value.Minutes}</td>
                        <td>{value.Count}</td>
                        <td>{value.Remarks}</td>
                        <td>{value.approved_date}</td>
                        <td>{value.timesheetfilleddt}</td>
                    </tr>));
                }); 
            
                let totalpage = response.data.data.total; 
                setPages(totalpage);
                setDatacomp(emparr);
                setDatastate(true);
                setloading(true);
            }else{
                setDatacomp([]);  
                setDatastate(false);
                setloading(true);
                setPages(0);
            }
        }).catch((error)=>{
            console.log(error);
            setDatacomp([]);  
            setDatastate(false);
            setloading(true);
            setPages(0);
        });
    }  

    function getemplist(){
        let member = userdata.id;
        let managerid = member;
        let emparr = [];
        timesheetreportService.getemployeelist({managerid:managerid}).then((response)=>{
           console.log(response);
           response.data.data.forEach((value,index) =>{
              emparr.push((<option value={value.id}>{value.name}</option>));
           });
           setempcomp(emparr);
        }).catch((error)=>{

        });  
    }

    function _getclientslist(){
        let managerid = 1;
        let emparr = [];
        timesheetreportService.getclientslist({managerid:managerid}).then((response)=>{
            // console.log(response);
            response.data.data.forEach((value,index) =>{
                if(value.client != ''){
                    emparr.push((<option value={value.client}>{value.client}</option>));     
                }
            });
            setClientscomp(emparr);
         }).catch((error)=>{
 
         });    
    }

    function _getsubclient({clientid}){
        try{
            let _clientid = clientid;
            let emparr = [];
            timesheetService.getallsubclient({client:_clientid}).then((response)=>{
                // console.log(response);
                if(response != undefined){
                    response.data.data.forEach((value,index) =>{
                        if(value.subclient != ''){
                            emparr.push((<option value={value.subclient}>{value.subclient}</option>));
                        }
                    });
                    setsubClientscomp(emparr);
                }
             }).catch((error)=>{
            
             }); 
        }catch(e){
           console.log(e);
        }
    }

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        let pageno = 1;
        if(event.first == 0){
         pageno = 1;    
        }else{
         pageno = ((event.first/rows) + 1);  
        }
        // getUsers(pageno);
        getreports({reportobj:filterobj,pageno:pageno});
        // console.log(pageno);
    };

    const exportexcel = () =>{
        if(formData.fromdate == ''){
            toast.current.show({severity:'error', summary: "Required", detail:`Month Field is required`, life: 3000});          
             return;
        }
       let reportobj = {
        'clientid':formData.client,
        'frmdt':formatterhelper.dateformatter({date:formData.fromdate}),
      };

      setDataexport(false);
      timesheetService.getfinaladjustment(reportobj).then((response)=>{        
        console.log("response");
        console.log(response);  
        if(response.status == 200){
            exportToExcel(response.data.data);
        }else{
            
        }
        }).catch((error)=>{
            console.log(error);
          
        });  
       
    }

    function exportToExcel(data) {
        dataExporthelper.exportFromhtml({id:'adjustmentdatatable',reportname:'FinalAdjustmentreport'});
        // dataExporthelper.exportToExcel(data,{filename:'FinalAdjustmentreport'});
        // const ws = XLSX.utils.json_to_sheet(data);
        // const wb = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        // XLSX.writeFile(wb, 'exported_data.xlsx');
    }


    function addnewadjustment(){
        getallusers();
        setVisibility2(true);  
    }

    function getallusers(){
        timesheetuserService.getalluserslist().then((response)=>{ 
              let emparr = [];
              if(response.status == 200){
                   console.log(response);
                   console.log("response data");
                   if(response != undefined){
                    response.data.data.forEach((value,index) =>{
                        if(value.name != ''){
                            emparr.push((<option value={value.id}>{value.name}</option>));
                        }
                        });
                        setUserscomp(emparr);
                    }
              }else{
                console.log("response error");
              }
        }).catch((error)=>{
            console.log("response error");
        });
    }

    function handlechangeadddata(e){
        const { name, value } = e.target;
        setFormData3((prevData) => ({
          ...prevData,
          [name]: value,
        }));

        if(name == 'client'){
            _getsubclient({clientid:value}); 
        } 
    }

    function handleSubmitform3(e){
        e.preventDefault();
        // console.log(formatterhelper.dateformatter({date:formData3.selectmonth}));
        // console.log("form data submit 3");
        // console.log(formData3); 
        let objdata = {
            'selectmonth': formatterhelper.dateformatter({date:formData3.selectmonth}),
            'selectuser': formData3.selectuser,
            'client':formData3.client,
            'subclient':formData3.subclient,
            'value':formData3.value,
        };   
        console.log('objdata'); 
        console.log(objdata);
        timesheetuserService.addnewadjustmentdata(objdata).then((response)=>{
           if(response.status == 200){
            toast.current.show({severity:'success', summary: "Final bill adjustment", detail:`Adjustment added`, life: 3000});
            setFormData3(formData3);
            setFormData3(formData3.value = ''); 
            
            setVisibility2(false);    
           }else{
            toast.current.show({severity:'error', summary: "Final bill adjustment", detail:`Adjustment updated`, life: 3000}); 
           }
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Final bill adjustment", detail:`Error`, life: 3000});
        });
    }
    
    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <div className="invisible-divider-sm"></div>
            <h6>Delete Adjustment</h6>
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Month</label>
                        <Calendar view='month' required value={formData.fromdate} name="fromdate" onChange={handleChange} className='calender-custom-style' />
                        {errors.fromdate && <span className='error'>{errors.fromdate}</span>}
                    </div>
                    
                 
                    <div className="col-md-2">
                        <label className='pull-left'>Client</label>
                        <select className='form-control' name='client' value={formData.client} onChange={handleChange}>
                            <option value='ALL'>ALL</option>
                            {cleintscomp}
                        </select>
                        {errors.client && <span className='error'>{errors.client}</span>}
                    </div>
                    
                    <div className="col-md-2">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Show" severity="success" rounded className='custom-btn-style' />
                            &nbsp;&nbsp;&nbsp; 
                            <Button type='button' stype="button" label="Export" severity="info" rounded className='custom-btn-style' onClick={()=>exportexcel()}> {!isdataexported ? (loader.Loadermd()) : (<></>) }</Button> 
                        </div>
                        
                    </div>

                    <div className="col-md-4">
                        <div className='button-wrapper-style'>
                            <Button type='button'  stype="button" label="Add New Adjustment" onClick={() => addnewadjustment()} severity="info" rounded className='custom-btn-style pull-right'></Button> 
                        </div>
                    </div>
                   
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                        {isloaded && dataavail ? (<Paginator first={first} rows={rows} totalRecords={totalpages} rowsPerPageOptions={[15]} onPageChange={onPageChange} />) : (<></>)}
                        
                    </div>
                </div>
               
                <div className='row'>
                    <div className='col-md-12'>
                    {!isloaded ? loader.Loadermd() : dataavail ?
                    (
                        <table class="table table-bordered" id="adjustmentdatatable">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Date</th>
                                <th scope="col">Name</th>
                                <th scope="col">Client</th>
                                <th scope="col">Sub Client</th>
                                <th scope="col">Final value</th>
                                <th scope="col">Action</th>
                               
                            </tr>
                        </thead>
                        <tbody>
                            {displayadjsdata()}
                        </tbody>
                    </table>
                    ) : (<p>No data Found</p>)}
                </div>
                </div>
            </div>

             {/* // edit adjustment  */}
            <Dialog header="Edit Adjustment" position='top' visible={popupvisible} style={{ width: '60vw' }} onHide={() => setVisibility(false)}>
               <form onSubmit={(e) => handleSubmitform2(e)}>
               <div className='col-md-12'>
                  <div className='row'>
                      <div className='col-md-12'>
                      </div>
                  </div>
                 <div className='row'>
                    <div className='col-md-3'>
                        <label><Mandate/>Date</label>
                        <input type="text" className='form-control' disabled={true} value={adjustmentvalues.from_date}/>    

                        {/* <select className='custom-dropdown-style' required name="client" class="form-control" onChange={(e) => handlechangeddata(e) }>
                           <option value="">select</option>
                           {cleintscomp}
                        </select> */}
                     </div>
                     <div className='col-md-3'>
                        <label><Mandate/>Select Client</label>
                        <input type="text" className='form-control' disabled={true} value={adjustmentvalues.client}/>    

                        {/* <select className='custom-dropdown-style' required name="client" class="form-control" onChange={(e) => handlechangeddata(e) }>
                           <option value="">select</option>
                           {cleintscomp}
                        </select> */}
                     </div>
                     <div className='col-md-3'>
                        <label><Mandate/>Select SubClient</label><span></span> 
                        <input type="text" className='form-control' disabled={true} value={adjustmentvalues.subclient}/>
                        {/* <select className='custom-dropdown-style' required name="subclient" onChange={(e) => handlechangeddata(e)} class="form-control">
                           <option value="">Select</option>
                           {subclientscomp}
                        </select> */}
                     </div>
                     <div className='col-md-3'>
                        <label><Mandate/>Values</label><span></span> 
                        <input type="text" className='form-control' name="value" value={adjustmentvalues.value} onChange={(e) => handlechangeddata(e)}/>
                        {/* <select className='custom-dropdown-style' required name="subclient" onChange={(e) => handlechangeddata(e)} class="form-control">
                           <option value="">Select</option>
                           {subclientscomp}
                        </select> */}
                     </div>
                  </div> 
                  <br/>  
                  

                  <div className='row'>
                    <div> 
                      <div className='pull-right'>
                          <span>
                           <Button type="submit" label="Save" severity="success" rounded />
                          </span>
                          <span>
                          <Button type="button" onClick={() => setVisibility(false)} stype="button" label="Close" severity="danger" rounded /> 
                          </span>
                      </div>
                    </div>
                  </div>    
               </div>
              </form>
             </Dialog>

             {/* // add new adjustment  */}
             <Dialog header="Add Adjustment" position='top' visible={popupvisible2} style={{ width: '60vw' }} onHide={() => setVisibility2(false)}>
               <form onSubmit={(e) => handleSubmitform3(e)}>
               <div className='col-md-12'>
                  <div className='row'>
                      <div className='col-md-12'>
                      </div>
                  </div>
                 <div className='row'>
                    <div className='col-md-3'>
                        <label><Mandate/>Select Month</label>
                        <Calendar view='month' required name="selectmonth" onChange={(e)=> handlechangeadddata(e)} className='calender-custom-style' /> 
                        {/* <input type="text" className='form-control' disabled={true} value={adjustmentvalues.from_date}/>     */}

                        {/* <select className='custom-dropdown-style' required name="client" class="form-control" onChange={(e) => handlechangeddata(e) }>
                           <option value="">select</option>
                           {cleintscomp}
                        </select> */}
                     </div>
                     <div className='col-md-3'>
                        <label><Mandate/>Select User</label>
                        {/* <input type="text" className='form-control' disabled={true} value={adjustmentvalues.client}/>     */}

                        <select className='custom-dropdown-style' required name="selectuser" class="form-control" onChange={(e) => handlechangeadddata(e) }>
                           <option value="">select</option>
                           {userscomp}
                        </select>
                     </div>

                     <div className='col-md-3'>
                        <label><Mandate/>Select Client</label>
                        <select className='form-control' required name='client' onChange={(e) => handlechangeadddata(e)}>
                            <option value=''>Select Client</option>
                            {cleintscomp}
                        </select>

                        {/* <select className='custom-dropdown-style' required name="client" class="form-control" onChange={(e) => handlechangeddata(e) }>
                           <option value="">select</option>
                           {cleintscomp}
                        </select> */}
                     </div>
                     <div className='col-md-3'>
                        <label><Mandate/>Select SubClient</label><span></span> 
                        <select className='custom-dropdown-style' required name="subclient" onChange={(e) => handlechangeadddata(e)} class="form-control">
                           <option value="">Select subclient</option>
                           {subclientscomp}
                        </select>
                     </div>
                     <div className='col-md-3'>
                        <br/>
                        <label><Mandate/>Values</label><span></span> 
                        <input type="text" className='form-control' value={formData3.value} required name="value" onChange={(e) => handlechangeadddata(e)}/>
                        {/* <select className='custom-dropdown-style' required name="subclient" onChange={(e) => handlechangeddata(e)} class="form-control">
                           <option value="">Select</option>
                           {subclientscomp}
                        </select> */}
                     </div>
                  </div> 
                  <br/>  
                  

                  <div className='row'>
                    <div> 
                      <div className='pull-right'>
                          <span>
                           <Button type="submit" label="Save" severity="success" rounded />
                          </span>
                          <span>
                          <Button type="button" onClick={() => setVisibility2(false)} stype="button" label="Close" severity="danger" rounded /> 
                          </span>
                      </div>
                    </div>
                  </div>    
               </div>
              </form>
             </Dialog>


            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default FinalbillDelete;